import { BACKEND_BASE_URL } from "config/api";

const backendBase = BACKEND_BASE_URL;
// Keep trailing path handling consistent across callers
const server_url = `${backendBase}/api`;

export { server_url };
export { backendBase };
export const adminEmail = "superadmin@kifaytihealth.com";
